import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import VirtualAccountService from "services/loanMgt/virtualaccount/virtualaccountservice";

export const initialState = {
  loading: false,
  virtualAccountList: [],
};

export const getVirtualAccountList = createAsyncThunk(
  "virtualAccount/getVirtualAccountList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await VirtualAccountService.getVirtualAccountList(data);

      // Defensive about shape — the backend controller's declared return
      // type doesn't match its query interface's declared type (see
      // memory: virtualaccount-backend-not-deployed), so don't assume a
      // bare array the way the old finstrust_lms source did.
      if (Array.isArray(response?.data)) return response.data;
      if (Array.isArray(response?.data?.data)) return response.data.data;
      if (Array.isArray(response?.data?.result)) return response.data.result;

      return [];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const virtualAccountSlice = createSlice({
  name: "virtualAccount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVirtualAccountList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVirtualAccountList.fulfilled, (state, action) => {
        state.loading = false;
        state.virtualAccountList = action.payload;
      })
      .addCase(getVirtualAccountList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default virtualAccountSlice.reducer;
